import approvalInsertTransaction from './approval-insert-transaction';
import approvalInsertFileOffUs from './approval-insert-file';
import historyInsertTransaction from './history-insert-transaction';
import historyTransactionFile from './history-insert-file';
import insertTransaction from './insertTransaction';

export default {
  approvalInsertTransaction,
  historyInsertTransaction,
  historyTransactionFile,
  insertTransaction,
  approvalInsertFileOffUs
};